import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);
const STORAGE_KEY = "dr_cart";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch {
      return [];
    }
  });
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [discountCode, setDiscountCode] = useState(() => localStorage.getItem("dr_discount") || "");

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  useEffect(() => {
    if (discountCode) localStorage.setItem("dr_discount", discountCode);
    else localStorage.removeItem("dr_discount");
  }, [discountCode]);

  const addItem = (product, size, qty = 1) => {
    setItems((prev) => {
      const idx = prev.findIndex((i) => i.slug === product.slug && i.size === size);
      if (idx >= 0) {
        const next = [...prev];
        next[idx] = { ...next[idx], qty: Math.min(10, next[idx].qty + qty) };
        return next;
      }
      return [...prev, { slug: product.slug, name: product.name, price: product.price, size, qty, image: product.images[0] }];
    });
    setDrawerOpen(true);
  };

  const removeItem = (slug, size) =>
    setItems((prev) => prev.filter((i) => !(i.slug === slug && i.size === size)));

  const updateQty = (slug, size, qty) =>
    setItems((prev) =>
      qty <= 0
        ? prev.filter((i) => !(i.slug === slug && i.size === size))
        : prev.map((i) => (i.slug === slug && i.size === size ? { ...i, qty: Math.min(10, qty) } : i))
    );

  const clearCart = () => setItems([]);

  const { count, subtotal } = useMemo(() => {
    return {
      count: items.reduce((a, i) => a + i.qty, 0),
      subtotal: items.reduce((a, i) => a + i.qty * i.price, 0),
    };
  }, [items]);

  const discount = useMemo(() => {
    if (discountCode.toUpperCase() === "DR10") return subtotal * 0.1;
    return 0;
  }, [discountCode, subtotal]);

  const value = { items, addItem, removeItem, updateQty, clearCart, count, subtotal, discount, discountCode, setDiscountCode, drawerOpen, setDrawerOpen };
  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
}

export function useCart() {
  return useContext(CartContext);
}
